import React from 'react';

const PlantHero = ({ plant, archived }) => {
  return (
    <div className="mt-4">
      <h3 className="tracking-widest text-accent-500 text-xs font-medium title-font">
        {plant.scientificName}
      </h3>
      <h2 className="text-lg text-gray-900 font-medium title-font mt-1">
        {plant.name}
      </h2>
      {archived && (
        <h3 className="leading-relaxed text-base text-gray-900">
          from {plant.areaName}
        </h3>
      )}
      <p className="leading-relaxed text-base mt-4">{plant.description}</p>
    </div>
  );
};

export default PlantHero;
